/* unplugin-vue-components disabled */import { render } from "./ShareUserAgreement.vue?vue&type=template&id=789d5071&scoped=true"
import script from "./ShareUserAgreement.vue?vue&type=script&lang=js"
export * from "./ShareUserAgreement.vue?vue&type=script&lang=js"

import "./ShareUserAgreement.vue?vue&type=style&index=0&id=789d5071&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/plp-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789d5071"]])

export default __exports__